import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useGetParkingById = (id: string | number) => {
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['parkings', id],
    queryFn: () => API.getParkingById(id),
    retry: 1,
    //  select: (data) => data.data.payload.address,
  });

  const address = data ? data.formatted_address : '';

  return { address, data: data?.data.payload, isLoading, refetch, isSuccess };
};
